export default __webpack_public_path__ + "static/media/invision-white-slim.292fa475.png";